import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import SEO from '../../components/seo';
import TrailTitle from '../../components/TrailTitle';
import { graphql } from 'gatsby';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const delay = keyframes`
  0% {
    opacity: 0;
    height : 0;
  }

  100% {
    opacity: 0;
    height : initial;
  }
`;

const fade = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const DelayFade = styled(Col)`
  animation: ${delay} ${(props) => props.order * 0.5}s,
    ${fade} 0.5s ${(props) => props.order * 0.5}s;
`;

const MottoPage = ({ data, location }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);

  return (
    <>
      <SEO title='Moto dan Budaya' pathname='/about/motto' />
      <Img fluid={data.cover.childImageSharp.fluid} />
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'
          css={{ justifyContent: 'space-between' }}>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Visi, Misi, Motto</div>
            <div>RSGM Bhakti Wiyata</div>
          </TrailTitle>
        </Col>

        <Col xs={'12'} sm={{ span: '8', offset: 2 }} className='py-3'>
          <div>
            <h3 className="font-weight-bold">Visi RSGM Bhakti Wiyata</h3>
            <p className="">RSGM Bhakti Wiyata memiliki visi memberikan pelayanan kesehatan serta pendidikan yang bermutu dan terjangkau dengan mengutamakan kepuasan pelanggan menuju terwujudnya kemandirian untuk hidup sehat.</p>
          </div>
        </Col>

        <Col xs={'12'} sm={{ span: '8', offset: 2 }} className='py-3'>
          <div>
            <h3 className="font-weight-bold">Misi RSGM Bhakti Wiyata</h3>
            <p className="">
              RSGM Bhakti Wiyata memiliki misi:
              <ol>
                <li>Menjadikan Rumah Sakit Gigi dan Mulut Institut Ilmu Kesehatan Bhakti Wiyata yang bermutu, dengan memberikan pelayanan prima serta pendidikan yang unggul demi kepuasaan pelanggan.</li>
                <li>Meningkatkan kualitas sumber daya manusia yang profesional.</li>
                <li>Menciptakan kemandirian masyarakat untuk hidup sehat.</li>
              </ol>
            </p>
          </div>
        </Col>

        <Col xs={'12'} sm={{ span: '8', offset: 2 }}>
          <div>
            <Row className='mb-4'>
              <Col xs={'6'}>
                <h3 className='font-weight-bold'>Motto RSGM Bhakti Wiyata</h3>
              </Col>
              <Col xs={'6'}>
                <h4 className='font-weight-bold text-right'>Service Excellence with a Smile</h4>
              </Col>
            </Row>
            <div className='py-3'>
              <h3 className='font-weight-bold'>Budaya RSGM Bhakti Wiyata</h3>
            </div>
            <Row className='p-1'>
              {data.mottos.edges.map(
                ({ node: { cockpitId, name, logo, description } }, idx) => (
                  <DelayFade sm={'3'} key={cockpitId} order={idx}>
                    <div className='d-flex flex-column justify-content-center align-items-start align-content-center'>
                      <Img
                        fixed={logo.value.childImageSharp.fixed}
                        className='align-self-center mb-3'
                      />
                      <h5 css={{ fontWeight: 'bold' }}>{name.value}</h5>
                      <p>{description.value}</p>
                    </div>
                  </DelayFade>
                )
              )}
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
};

export const query = graphql`
  {
    mottos: allCockpitMottos(filter: { display: { value: { eq: true } } }) {
      edges {
        node {
          cockpitId
          name {
            value
          }
          description {
            value
          }
          logo {
            type
            value {
              childImageSharp {
                fixed(width: 200, toFormat: WEBP) {
                  ...GatsbyImageSharpFixed_withWebp
                }
              }
            }
          }
        }
      }
    }
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    cover: file(name: { eq: "bg-motto" }) {
      childImageSharp {
        fluid(maxWidth: 1920, toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default MottoPage;
